import homeImg from '../assets/icons/home.svg';
import questionImg from '../assets/icons/question.svg';

export default function Header (props) {
	//{console.log(props)}
	const title = 'Терминология айкидо';
	return (
		<header className='header flex-2 bg-blue-200'>
			<div className="header__inner container flex flex-col justify-between mx-auto py-4 px-8 uppercase">
				<div className="header__top  flex justify-center items-center">
					<h1 className='text-3xl whitespace-nowrap'>{title}
					</h1>
				</div>
				<div className="header__bottom  flex justify-between items-center">
					<div className="header__left flex">
						<div className="menu">
							<input 
							id="menu__toggle" 
							type="checkbox" 
							checked={props.open}
							onChange={props.myChange}
							/>
							<label className="menu__btn" htmlFor="menu__toggle">
								<span></span>
							</label>
						</div>
						<a href="/" className='home-link ml-2 flex shrink-0'>
							<img src={homeImg} className="flex shrink-0" alt="home" />
						</a>
					</div>
					<h1 className='header__title text-4xl whitespace-nowrap'>{title}</h1>
					<div className="switch opacity-0 hidden">
						<label htmlFor="selector" className='pr-2'>Тренировка</label>
						<input type="checkbox" id="selector"></input>
					</div>
					<button 
					className='header__btn-info w-9 h-9 flex shrink-0'
					onClick={props.info}
					><img src={questionImg} className="flex shrink-0" alt="info" /></button>
				</div>
			</div>
		</header>
	)
	
}